import React, { useState } from 'react';
import { get } from 'lodash';
import MentorCard from 'components/mentoring/mentor/MentorCard';
import MentorUpcomingClass from 'components/mentoring/mentor/MentorUpcomingClass';
import MentoringPastClass from 'components/mentoring/MentoringPastClass';
import { MentoringClassWrapper } from 'components/mentoring/styles';
import { getCurrentMentor } from 'libs/api/user';
import { useDataApi } from 'libs/hooks';
import { TMentor } from 'modules/user';
import { TUser } from 'modules/user';
import { CWindowWidth } from 'constants/base.const';
import { EUserType } from 'enums/base.enum';
import { Col, Row, Typography, Divider, Spin, Button } from 'antd';
import styled from 'styled-components';
import MentoringReviewsModal from '../MentoringReviewsModal';
import { TModalState } from 'modules/types';
import { TMentoringReview2 } from 'modules/mentoring';
import { mentoringReviewCreate2 } from 'libs/api/mentoring';

const { Text, Title } = Typography;
const MentorMyPageWrapper = styled.div`
  color: #000;
  font-size: 16px;

  .small-btn {
    padding: 0px 20px !important;
    font-size: 13px;
  }
`;

const MentorMyPage = ({ user }: { user: TUser | undefined }) => {
  const [{ data, loading }] = useDataApi<TMentor>(getCurrentMentor.bind(null));
  const [mentoringReviewsModal, setMentoringReviewsModal] = useState<TModalState>({
    visible: false,
  });
  return (
    <MentoringClassWrapper>
      <Spin tip='loading...' spinning={false}>
        <Row
          style={{
            maxWidth: `${CWindowWidth - 300}px`,
            margin: '20px auto',
            padding: '30px 10px',
          }}
          gutter={[32, 16]}
        >
          <Col
            xs={{ span: 24, order: 2 }}
            sm={{ span: 24, order: 2 }}
            md={{ span: 16, order: 1 }}
            lg={{ span: 16, order: 1 }}
            xl={{ span: 17, order: 1 }}
          >
            <Title level={2} style={{ marginBottom: '0px' }}>
              나의 멘토링 관리
            </Title>
            {get(data, 'can_mentoring') === false && (
              <div style={{ color: '#000', fontSize: '12px', marginTop: '5px' }}>
                • 현재는 McKinsey, BCG, Bain 분들만 멘토로 모집하고 있습니다. 최대한 빠른 시일 내에 서비스를
                확대하고, 안내 드리겠습니다.
              </div>
            )}
            <MentorUpcomingClass />
            <Divider />
            <div style={{ marginBottom: '10px', marginTop: '32px' }} className='content-title'>
              <Row justify='space-between' align='middle'>
                <Col>지난 멘토링</Col>
                <Col>
                  <Button 
                    type='primary'
                    onClick={() => {
                      /*mentoringReviewCreate2(
                        {
                          score: 4,
                          comment: "test comment",
                          comment_extra: "test comment_extra",
                          score_contents: 4,
                          score_communication: 4,
                          score_professionalism: 4,
                          tags: [0,1,2],
                          mentoring_class_id: 1219
                        } as TMentoringReview2
                      )*/
                      setMentoringReviewsModal({
                        visible: true,
                        isView: true,
                        record: data.id,
                      });
                    }}>멘티가 남긴 리뷰 보기</Button>
                </Col>
              </Row>
            </div>
            <MentoringPastClass targetType={EUserType.Mentee} />
            { mentoringReviewsModal.visible ? <MentoringReviewsModal modalState={mentoringReviewsModal} setModalState={setMentoringReviewsModal} /> : <div></div> }
          </Col>
          <Col
            xs={{ span: 24, order: 1 }}
            sm={{ span: 24, order: 1 }}
            md={{ span: 7, offset: 1 }}
            lg={{ span: 7, offset: 1 }}
            xl={{ span: 6, offset: 1 }}
            style={{ textAlign: 'center' }}
          >
            <MentorCard style={{ margin: 'auto' }} mentor={data} isCurrentUser={true} />
          </Col>
        </Row>
      </Spin>
    </MentoringClassWrapper>
  );
};

export default MentorMyPage;
